module.exports = __webpack_public_path__ + "img/bg_lan_sj.cf9cb267.png";